
import './style.css';

import Translations from '../../data/Translations';
import EventsArray from '../../data/Events';
import LazyImage from '../../components/LazyImage/LazyImage';
import EventModal from './EventModal';

const Events = ({ currentLanguage }) => {
    return (
        <>
            <section id="events" class="events section-bg">
                <div class="container" data-aos="fade-up">

                    <div class="section-title">
                        <h2>{Translations.events[currentLanguage]}</h2>
                        <p>{Translations.eventsTitle[currentLanguage]}</p>
                    </div>

                    <div class="row content">
                        <div class="col-lg-12">
                            <p>
                                {Translations.eventsDescription[currentLanguage]}
                            </p>
                        </div>
                    </div>

                    <div class="row" data-aos="fade-up" data-aos-delay="100">
                        {
                            EventsArray.map((item, index) => {
                                const id = `event-${index}`;

                                return (
                                    <>
                                        <div className="col-lg-4 col-md-6" key={index}>
                                            <div
                                                className="member"
                                                data-bs-toggle="modal"
                                                data-bs-target={`#${id}`}
                                            >
                                                <div className="pic">
                                                    <LazyImage
                                                        src={item.images[0]}
                                                        alt={item.name[currentLanguage]}
                                                    />
                                                </div>

                                                <div className="member-info">
                                                    <h4>{item.name[currentLanguage]}</h4>
                                                </div>
                                            </div>
                                        </div>

                                        <EventModal
                                            event={item}
                                            currentLanguage={currentLanguage}
                                            id={id}
                                        />
                                    </>
                                );
                            })
                        }
                    </div>
                </div>
            </section>
        </>
    )
}

export default Events;